<section class="section-novedades">
  <div class="novedades-container">
    <!-- Header -->
    <div class="novedades-header">
      <h2 class="title">Novedades</h2>
      <p class="subtitle">Estas son algunas de nuestras novedades en el menú</p>
    </div>

    <!-- Grid -->
    <div class="novedades-grid">
      <article class="producto">
        <div class="producto-imagen">
          <img
            src="assets/images/BoraDobleTentacion.png"
            alt="Bora Doble Tentación"
          />
          <a class="producto-boton" href="#">Quiero una!</a>
        </div>

        <h4 class="producto-titulo">Bora Doble Tentación</h4>
        <p class="producto-precio">$16.500</p>
      </article>

      <article class="producto">
        <div class="producto-imagen">
          <img
            src="assets/images/BoraPromo1.png"
            alt="Simple Cheese + Empanadas"
          />
          <a class="producto-boton" href="#">Quiero una!</a>
        </div>

        <h4 class="producto-titulo">Simple Cheese + Empanadas</h4>
        <p class="producto-precio">$9.700</p>
      </article>

      <article class="producto">
        <div class="producto-imagen">
          <img src="assets/images/BoraSandwich.png" alt="Milanesa de carne" />
          <a class="producto-boton" href="#">Quiero una!</a>
        </div>

        <h4 class="producto-titulo">Milanesa de carne</h4>
        <p class="producto-precio">$9.800</p>
      </article>
    </div>
  </div>
</section>
